module.exports = __webpack_public_path__ + "static/media/unfav-copy.5bdbc084.svg";